import { inject, Injectable } from '@angular/core';
import { INativeBridge, NativeBridgeWindow } from './native-bridge.interface';
import { AndroidService } from './android/android.service';
import { IosService } from './ios/ios.service';

declare const window: NativeBridgeWindow;

export function isAndroidBridgeAvailable(): boolean {
  return !!window['android'];
}

export function iOSBridgeAvailable(): boolean {
  return !!window['webkit'] && window['webkit']['messageHandlers'] && !!window['webkit']['messageHandlers']['pacific'];
}

export function isMobile(): boolean {
  return iOSBridgeAvailable() || isAndroidBridgeAvailable();
}

@Injectable({
  providedIn: 'root'
})
export class MobileService {
  private androidService = inject(AndroidService);
  private iosService = inject(IosService);

  private _nativeBridge: INativeBridge;
  
  constructor() {
    if (isAndroidBridgeAvailable()) {
      console.log('Android bridge available');
      this._nativeBridge = this.androidService;
    } else if (iOSBridgeAvailable()) {
      console.log('iOS bridge available');
      this._nativeBridge = this.iosService;
    } else {
      console.log('No mobile bridge available');
    }
  }

  public getNativeBridge(): INativeBridge {
    return this._nativeBridge;
  }
}